import { useEffect, useRef, useState } from 'react';
import { guideApi, type GuideItem } from '../api';
import { usePrefs } from '../prefs';

/**
 * Kaart bij de start van een film of aflevering (zoals streamingdiensten en DexHub): de leeftijd groot,
 * waarom (IMDb Parents Guide: alleen matig en heftig) en een regel met beeld en geluid.
 * Komt één keer, blijft een paar seconden en verdwijnt. Uit te zetten bij Kijken → Afspelen.
 */
export function RatingCard({ imdb, tmdb, type, age, tech, show }: {
  imdb?: string | null;
  tmdb?: number | null;
  type?: 'movie' | 'tv';
  age?: string | null;
  tech?: string | null;
  /** Wordt true als het beeld echt loopt */
  show: boolean;
}) {
  const prefs = usePrefs();
  const [data, setData] = useState<{ certification: string | null; guide: GuideItem[] } | null>(null);
  const [visible, setVisible] = useState(false);
  const shown = useRef(false);

  useEffect(() => {
    if (!prefs.ratingCard || (!imdb && !tmdb)) return;
    let off = false;
    guideApi.get({ imdb: imdb ?? undefined, tmdb: tmdb ?? undefined, type }).then((r) => !off && setData(r)).catch(() => undefined);
    return () => { off = true; };
  }, [imdb, tmdb, type, prefs.ratingCard]);

  useEffect(() => {
    if (!show || shown.current || !prefs.ratingCard) return;
    shown.current = true;
    setVisible(true);
    const t = window.setTimeout(() => setVisible(false), 7000);
    return () => window.clearTimeout(t);
  }, [show, prefs.ratingCard]);

  const rating = age || data?.certification || null;
  const reasons = (data?.guide ?? []).filter((g) => g.level === 'MODERATE' || g.level === 'SEVERE').map((g) => g.label);
  if (!prefs.ratingCard || !visible || (!rating && !reasons.length)) return null;
  return (
    <div className="rating-card" role="status" aria-live="polite">
      <span className="rating-card-bar" aria-hidden="true" />
      <div className="rating-card-body">
        {rating && <span className="rating-card-age">{rating}</span>}
        {reasons.length > 0 && <span className="rating-card-why">{reasons.join(' · ')}</span>}
        {tech && <span className="rating-card-tech">{tech}</span>}
      </div>
    </div>
  );
}
